export default "<!-- {{{ body }}} -->\nBODY\n";